import styles from "./auth_style.module.css";
import { LoginImage } from "../../assets/svgs";

export const AuthPageBackgroundWrapper = ({ children }) => {
	return (
		<div className={`d-flex ${styles.background}`}>
			<div className={`${styles.white}`}>{children}</div>
			<div className={styles.imageContainer}>
				<LoginImage />
			</div>
		</div>
	);
};
